import { css } from '@emotion/react'
import styled from '@emotion/styled'

import type { Theme } from 'scripts/react-components/themes/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: description;

  color: ${theme.colors.n600};

  margin: ${theme.spacings.kilo} 0px ${theme.spacings.giga};
`

export const Wrapper = styled('div')(wrapperStyles)
